import { component$, Slot } from "@builder.io/qwik";

export const FeatureSection = component$<{
  preHeadline: string;
  headline: string;
  description: string;
  look: "active" | "inactive";
  layout: "left" | "right";
}>(({ preHeadline, headline, description, look, layout }) => {
  return (
    <div class="mt-8 flex flex-col items-stretch gap-8 md:mt-16 md:gap-16">
      <div class="mx-auto grid max-w-screen-lg gap-4 md:grid-cols-2 md:gap-12">
        <div class={layout === "left" ? "" : "md:col-start-2"}>
          <p
            class={`mb-4 text-sm font-medium uppercase tracking-wide ${
              look === "active" ? "text-violet-500" : "text-gray-500"
            }`}
          >
            {preHeadline}
          </p>
          <h3 class="mx-auto mb-4 text-2xl font-medium tracking-tight">
            {headline}
          </h3>
          <p class="text-md mb-4 leading-loose text-gray-800">{description}</p>
          <Slot />
        </div>
        <div
          class={`${
            layout === "left" ? "" : "md:col-start-1 md:row-start-1"
          } rounded-xl bg-gray-900 p-2 shadow-lg`}
        >
          <Slot name="image" />
        </div>
      </div>
    </div>
  );
});
